/**
 * @generated SignedSource<<8c3dbf1328d34c55627234c06fabc7a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type WhatToSeeBlocksFieldSectionsMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type WhatToSeeBlocksFieldSectionsMutation$data = {
  readonly updateWhatToSeeBlockPositions: boolean;
};
export type WhatToSeeBlocksFieldSectionsMutation = {
  response: WhatToSeeBlocksFieldSectionsMutation$data;
  variables: WhatToSeeBlocksFieldSectionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateWhatToSeeBlockPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WhatToSeeBlocksFieldSectionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WhatToSeeBlocksFieldSectionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e478f4db67c281aa7b5c498708cbe68",
    "id": null,
    "metadata": {},
    "name": "WhatToSeeBlocksFieldSectionsMutation",
    "operationKind": "mutation",
    "text": "mutation WhatToSeeBlocksFieldSectionsMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateWhatToSeeBlockPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "aa8e34b9c49998de5e0976db6a7954f4";

export default node;
